import React, { Component } from 'react';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import Loading from '../../../commons/Loading.js';

class AlertConfigurationServiceList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            saData: this.props.saData,
            loading: this.props.loading,
            showServiceAlert: this.props.showServiceAlert
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            saData: nextProps.saData,
            loading: nextProps.loading,
            showServiceAlert: nextProps.showServiceAlert
        });
    }

    indexFormat = (cell, row, enumObject, rowIndex) => {
        return (
            <div style={{display: 'flex'}}>
                <a href="#" onClick={() => this.setIndex(row.index)}>{cell}</a>
            </div>
        )
    }

    setIndex = (index) => {
        this.setState({showServiceAlert: index});
        this.props.updateShowServiceAlert(index);
    }

    createCustomToolBar = props => {
        const showServiceAlert = this.state.showServiceAlert;
        return (
            <div>
                <div className='searchFiled' style={{width: showServiceAlert === '' ? '' : '100%'}}>
                    { props.components.searchPanel }
                </div>
            </div>
        );
    }

    render() {
        const saData = this.state.saData;
        const showServiceAlert = this.state.showServiceAlert;
        const options = {
            defaultSortName: 'index',
            defaultSortOrder: 'asc',
            toolBar: this.createCustomToolBar,
            noDataText: this.state.loading ? <Loading /> : 'No service alert found.',
            searchDelayTime: 500
        };
        return (
            <div>
                <BootstrapTable data={ saData } search={ true } options={ options } striped hover condensed>
                    <TableHeaderColumn dataField='index' isKey dataSort={ true } width="15%" dataFormat={this.indexFormat}>Alert Index</TableHeaderColumn>
                    <TableHeaderColumn dataField='queryTitle' dataSort={ true } width="15%" hidden={showServiceAlert !== ''}>Query Title</TableHeaderColumn>
                    <TableHeaderColumn dataField='queryTimerInfo' dataSort={ true } width="15%" hidden={showServiceAlert !== ''}>Query Timer Information</TableHeaderColumn>
                    <TableHeaderColumn dataField='queryTimeRange' dataSort={ true } width="15%" hidden={showServiceAlert !== ''}>Query Time Range</TableHeaderColumn>
                    <TableHeaderColumn dataField='searchSize' dataSort={ true } width="15%" hidden={showServiceAlert !== ''}>Search Size</TableHeaderColumn>
                    <TableHeaderColumn dataField='alertType' dataSort={ true } width="15%" hidden={showServiceAlert !== ''}>Alert Type</TableHeaderColumn>
                    <TableHeaderColumn dataField='alertTimeout' dataSort={ true } width="10%" hidden={showServiceAlert !== ''}>Alert Timeout</TableHeaderColumn>
                </BootstrapTable>
            </div>
        );
    }
}

export default AlertConfigurationServiceList;


// WEBPACK FOOTER //
// ./src/modules/dashboard/alert-configuration/AlertConfigurationServiceList.js